<template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
      <tr>
        <th class="text-left" width="200px">Voornaam</th>
        <th class="text-left" width="400px">Achternaam</th>
        <th class="text-left" width="75px">Part 1</th>
        <th class="text-left" width="75px">Part 2</th>
        <th class="text-left" width="75px">Part 3</th>
        <th class="text-left" width="75px">Part 4</th>
        <th class="text-left" width="75px">Part 5</th>
        <th class="text-left">Part 6</th>
      </tr>
      </thead>
      <tbody>
      <tr :key='dstoremodule.id' v-for='dstoremodule in dstoremodules'>
        <td>{{dstoremodule.first_name}}</td>
        <td>{{dstoremodule.last_name}}</td>
        <td>
          <v-icon class="accent--text" v-show="dstoremodule.dfsmodule.ready_a"
          >mdi-check
          </v-icon
          >
          <v-icon class="primary--text" v-show="!dstoremodule.dfsmodule.ready_a"
          >mdi-minus-box
          </v-icon
          >
        </td>
        <td>
          <v-icon class="accent--text" v-show="dstoremodule.dfsmodule.ready_b"
          >mdi-check
          </v-icon
          >
          <v-icon class="primary--text" v-show="!dstoremodule.dfsmodule.ready_b"
          >mdi-minus-box
          </v-icon
          >
        </td>
        <td>
          <v-icon class="accent--text" v-show="dstoremodule.dfsmodule.ready_c"
          >mdi-check
          </v-icon
          >
          <v-icon class="primary--text" v-show="!dstoremodule.dfsmodule.ready_c"
          >mdi-minus-box
          </v-icon
          >
        </td>
        <td>
          <v-icon class="accent--text" v-show="dstoremodule.dfsmodule.ready_d"
          >mdi-check
          </v-icon
          >
          <v-icon class="primary--text" v-show="!dstoremodule.dfsmodule.ready_d"
          >mdi-minus-box
          </v-icon
          >
        </td>
        <td>
          <v-icon class="accent--text" v-show="dstoremodule.dfsmodule.ready_e"
          >mdi-check
          </v-icon
          >
          <v-icon class="primary--text" v-show="!dstoremodule.dfsmodule.ready_e"
          >mdi-minus-box
          </v-icon
          >
        </td>
        <td>
          <v-icon class="accent--text" v-show="dstoremodule.dfsmodule.ready_f"
          >mdi-check
          </v-icon
          >
          <v-icon class="primary--text" v-show="!dstoremodule.dfsmodule.ready_f"
          >mdi-minus-box
          </v-icon
          >
        </td>
      </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TabledStatus",
  data() {
    return {
      dataext: {},
    };
  },
  computed: {
    ...mapGetters("fchartDresult", ["dstoremodules"]),
  },
};


</script>

<style scoped>

</style>
